import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import axios from 'axios';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';

function SettingDate() {

  //Roles
  const ADMIN = 1;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [settingDate, setSettingDate] = useState([]);

  // CONTROLLER & LOAD DATA
  const fetchDataSettingDate = async () => {
    setIsLoading(true);
    await axios
      .all(
        [
        baseAPI .get(`/v1/dsetting`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const data = res[0].data.data.dataSetting;        
        setSettingDate(data)
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const deleteSettingDate = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You will delete this setting data, and you won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        await baseAPI
          .delete(`/v1/dsetting/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: 'Setting data has been deleted',
              showConfirmButton: false,
              timer: 1500
            })
          })
          .catch((error) => {
            setIsLoading(false);
            Swal.fire({
              icon: 'error',
              title: 'Delete setting data is failed',
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`error ${error}`)
          })
          .finally(() => {
            fetchDataSettingDate();
            setIsLoading(false);
          });
      }
    });
  }

  useEffect(() => {
    setIsLoading(true);
    if (users.role === ADMIN) {
      fetchDataSettingDate();
    }
  }, [token]);


  const contentTableAction = (id) => {
    if (id !== null) {
      return (
        <div className='text-center'>
          <Link 
            to={`/setting/settingdate/editsettingdate/${id}`} 
            className="btn btn-primary"
            style={{ backgroundColor: "#6A9C89", marginRight: 10 }}
          >
            <Icon name="Edit" size={16} />
          </Link>
          <button 
            className="btn btn-danger"
            onClick={() => deleteSettingDate(id)}
          >
            <Icon name="Trash" size={16} />
          </button>
        </div>
      )
    }
  };

  const settingListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'Date Name',
        id: 'nama',
        width: '10%',
        accessor: 'nama',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.date_name}</div>
      },
      {
        Header: 'Start Date',
        id: 'startdate',
        width: '8%',
        accessor: 'startdate',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.start_date}</div>
      },
      {
        Header: 'End Date',
        id: 'enddate',
        width: '15%',
        accessor: 'enddate',
        sortType: 'basic',
        // filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.end_date}</div>
      },
      {
        Header: 'Updated At',
        id: 'updatedat',
        width: '8%',
        accessor: 'updatedat',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{moment(cellInfo.row.original.updated_at).format('DD/MM/YYYY')}</div>
      },
      {
        Header: 'Action',
        id: 'action',
        width: '8%',
        Cell: (cellInfo) =>
          contentTableAction(
            cellInfo.row.original.id,
          )
      }
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Setting Date"
                columns={columns}
                data={settingDate}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Setting</Link> /{' '}
                <Link to='/setting/settingdate' style={{ color: '#333' }}>Setting Date</Link>
              </li>
            </ol>
          </div>

          {/* Tambah setting date */}
          <div className='col-auto ml-auto d-print-none'>
            <Link to="/setting/settingdate/tambahdate">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('tambah date')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Plus" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Tambah Date</span>
                </div>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )

  const handleView = () => {
    switch (users.role) {
      case ADMIN:
        return settingListView();
    }
  };
  
    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      {isLoading ? <LoadingView /> : handleView()}

    </div>

  );

}

export default SettingDate;